import type { GatewayUserSettings } from '../interfaces/gatewayUserSettings.interface'

export const DEFAULT_GATEWAY_USER_SETTINGS: GatewayUserSettings = {
  useCustom: false,
}
